import { AwpDashboard } from '@mdvip/shared/features/awp-dashboard/AwpDashboard';
import { useTranslation } from 'react-i18next';
import { HealthThemesHeader } from '@/components/dashboard/HealthThemesHeader';
import { useAuth } from '@/contexts/AuthContext';
import { useGreeting } from '@/hooks/useGreeting';

export function DashboardPage() {
  const { t } = useTranslation('members');
  const greeting = useGreeting();
  const { user } = useAuth();

  return (
    <div className="flex flex-col gap-6">
      <div>
        <h1 className="text-h1 font-semibold">{greeting}</h1>
        <p className="text-muted-foreground mt-1">{t('pages.dashboard.subtitle')}</p>
      </div>
      <HealthThemesHeader />
      <AwpDashboard memberId={user?.memberId} audience="member">
        <div className="rounded-lg border border-dashed p-12 text-center">
          <p className="text-muted-foreground">{t('pages.dashboard.empty')}</p>
        </div>
      </AwpDashboard>
    </div>
  );
}
